module.exports = __webpack_public_path__ + "assets/img/Smart-Structuring-Landing-Page-+-Website-w960.2b00fd18.webp";